webModule.controller('newQuoteController',
    ['$scope','$rootScope', '$location', '$route', '$timeout', 'welcomeEvents', 'growl', 'routes',
        'quoteIntegrationService', 'erateSessionVarsService', 'quoteIntegrationConstants', 'providerFeatureEvents','contractCreationService',
        'quoteInitializationService','rateQuoteCoordService','quoteCreationEvents','dealerDMSSearchService',
        'QuoteIntegrationLocal','contractInfoService','vehicleProductsProcessingService','rateQuoteRetrievalCoordService', 'financeService','imSessionVarsService',
    function ($scope, $rootScope, $location, $route, $timeout, welcomeEvents, growl, routes,
          quoteIntegrationService, erateSessionVarsService, quoteIntegrationConstants, providerFeatureEvents, contractCreationService,
          quoteInitializationService,rateQuoteCoordService,quoteCreationEvents, dealerDMSSearchService,
          QuoteIntegrationLocal, contractInfoService,vehicleProductsProcessingService,rateQuoteRetrievalCoordService, financeService,imSessionVarsService) {
            var _providerSpecificValidator = null;

            var dos = new Date();

            $scope.basicInfo = {
                vin: '',
                odometer: null,
                dos: dos,
                firstName: '',
                lastName: '',
                wMonths:'',
                wMiles:'',
                providerSpecific: {} // individual properties are created by directive in this controller's view
            };
            //dms integration/search data
            $scope.dmsInfo = {
                lookupInProgress :  false,
                dmsIntegrated : false,
                dealORStockNumber : '',
                dealORStockMode : '',
                dealORStockNumberOK : true,
                dmsDealsList : []
            };

            $scope.minDate='';
            $scope.maxDate = '';

            var _DMSTypesWithDealNumber = ['ADP_PIP', 'REYNOLDSRCI', 'AUTOMATE', 'AUTOSOFT', 'ASI_AUTOSOFT', 'EDATA'];
            var _DMSTypesWithStockNumber = ['ARKONA'];
            var _AUTOVEHICLETYPE = 'AUTO';
            $scope.init = function(){
                if (imSessionVarsService.getCurrentProviderCode() == "EASYCARE"){getMInMaxDOS(dos);}
                //determine dms integration, if any, and whether
                // we are searching by deal # or stock #
                dealerDMSSearchService.getDealerDMSInformation()
                .then(
                    function(dealerDMSInfo){
                        $scope.dmsInfo.dmsIntegrated = dealerDMSInfo.dmsIntegrated;
                        var dmsType = dealerDMSInfo.dmsType.toUpperCase();

                        if ($scope.dmsInfo.dmsIntegrated && _DMSTypesWithDealNumber.indexOf(dmsType) >= 0) { $scope.dmsInfo.dealORStockMode = 'DEALNUMBER'; }
                        else if ($scope.dmsInfo.dmsIntegrated && _DMSTypesWithStockNumber.indexOf(dmsType) >= 0) { $scope.dmsInfo.dealORStockMode = 'STOCKNUMBER'; }
                        else { $scope.dmsInfo.dmsIntegrated = false; }
                    },
                    function(err){
                        //if an error occurs, turn off DMS integration
                        $scope.dmsInfo.dmsIntegrated = false;
                    }
                )
            }

            // This is not used at present, because there is no longer a FAB specifically for required provider data
            // Todo: Need to figure out how to apply this to provider specific data, where ever it ends up.
            $scope.$on(providerFeatureEvents.metaDataRetrieved, function(event, args) {
                _providerSpecificValidator = args.validator;
                //console.log(args);
            });
            //just start a new quote with basic information
            $scope.beginBasicTransaction = function () {
                $scope.disableNew = true;
                var basicInfo = $scope.basicInfo;

                var integrationData = new QuoteIntegrationLocal();
                integrationData.dateOfSale = basicInfo.dos ? new Date(basicInfo.dos).mmddyyyy() : "";
                integrationData.vehicleInfo.vin = basicInfo.vin;
                integrationData.vehicleInfo.odometer = basicInfo.odometer;
                integrationData.primaryBuyerInfo.firstName = basicInfo.firstName;
                integrationData.primaryBuyerInfo.lastName = basicInfo.lastName;
                integrationData.vehicleInfo.wMonths = basicInfo.wMonths;
                integrationData.vehicleInfo.wMiles = basicInfo.wMiles;
                integrationData.providerSpecific = basicInfo.providerSpecific;
                integrationData.vehicleInfo.vehicleType = _AUTOVEHICLETYPE;
                rateQuoteCoordService.VehicleData.vehicleType = _AUTOVEHICLETYPE;//forcing recognition of event for AUTO

                $scope.clearQuotesContractsAndProducts();
                rateQuoteRetrievalCoordService.endQuoteRetrieval();//guarantees we've ended "quote retrieval"

                var currentPath = $location.path();
                erateSessionVarsService.setQuotingMode(quoteIntegrationConstants.newQuoteIntegrated);
                if (currentPath.indexOf(routes.createQuote) >= 0 ){
                    //reloading the page takes too long so simply updating necessary data
                    // and re-rating if we are already in "create quote" page
                    rateQuoteCoordService.startNewQuoteSession(true,true,true,true)
                    .then(
                        function(clearedData){
                            quoteIntegrationService.captureIntegrationData(integrationData);
                            $rootScope.$broadcast(quoteCreationEvents.customerDataChange, {});//forcing customer card refresh
                            $scope.basicInfo.vin = null;
                            $scope.basicInfo.providerSpecific = {};
                            $scope.basicInfo.dos = dos;
                            $scope.basicInfo.odometer = null;
                            $scope.basicInfo.firstName = null;
                            $scope.basicInfo.lastName = null;
                            $scope.basicInfo.wMonths = null;
                            $scope.basicInfo.wMiles = null;

                            rateQuoteCoordService.getNewGuid(false)
                            .then(function(guid){
                                $rootScope.$broadcast(quoteCreationEvents.startNewProductQuote, {newguid: guid});
                                //so that validation messages don't appear when they click new again
                                $scope.newQuoteForm.$setPristine();
                                $scope.dmsIntegrationForm.$setPristine();

                                if ($location.search()['qsession']) {
                                    $location.search('');
                                }
                            });
                        },
                        function(err){
                            throw err;
                        }
                    );
                } else {
                    //in a different page, so need to redirect to create-quote
                    // date of sale has to be in mm-dd-yyyy or mm/dd/yyyy format, in order to use quote integration service
                    quoteIntegrationService.captureIntegrationData(integrationData);
                    $location.url(routes.createQuote + '/?src=welcome');
                }
            };

            $scope.resetDMSDealOK = function() {
                $scope.dmsInfo.dealORStockNumberOK = true;
            }

            //DMS Integration - search for a deal
            $scope.beginDMSSearch = function() {
                //clear out existing data before we attempt to retrieve
                $scope.dmsInfo.dmsDealsList = null;
                $scope.dmsInfo.lookupInProgress = true;
                $scope.dmsInfo.dealORStockNumberOK = true;

                //get the field entered
                var dealOrStock = $scope.dmsInfo.dealORStockNumber;
                //call the search service
                dealerDMSSearchService.searchDMS(($scope.dmsInfo.dealORStockMode == 'DEALNUMBER' ? dealOrStock : null), ($scope.dmsInfo.dealORStockMode == 'DEALNUMBER' ? null : dealOrStock))
                .then(
                    function receivedDMSDeal(ready){
                        $scope.dmsInfo.lookupInProgress = false;
                        //if we get a single item from the search, just select it and start quoting
                        if (ready && !angular.isArray(dealerDMSSearchService.dmsDealData)){
                            $scope.selectDeal(dealerDMSSearchService.dmsDealData);
                            $scope.dmsInfo.dealORStockNumberOK = true;
                            //closing the window
                        }else if (ready && angular.isArray(dealerDMSSearchService.dmsDealData)){
                            $scope.dmsInfo.dmsDealsList = dealerDMSSearchService.dmsDealData;
                            $scope.dmsInfo.dealORStockNumberOK = true;
                        }
                        //for some reason we got no data back
                        else{ $scope.dmsInfo.dealORStockNumberOK = false; }
                    },
                    function errRetrievingDeal(err){
                        $scope.dmsInfo.dealORStockNumberOK = false;
                        $scope.dmsInfo.lookupInProgress = false;
                    }
                )
            }

            $scope.clearQuotesContractsAndProducts = function(){
                financeService.clearQuotesToCalculate();
                contractCreationService.initContractInfo();
                contractInfoService.clearQuoteQueueInfo();
                vehicleProductsProcessingService.clearRateSummaryDataAndProducts();
            }

            //selecting a deal and starting up the quote
            $scope.selectDeal = function(myDealData){
                $scope.resetDMSDealOK();
                $scope.dmsInfo.dmsDealsList = [];
                //clear out previous data
                erateSessionVarsService.setQuotingMode(quoteIntegrationConstants.newQuoteIntegrated);
                quoteIntegrationService.captureIntegrationData({});
                quoteInitializationService.initializeCustomerData();
                quoteInitializationService.initializeDealData();
                quoteInitializationService.initializeVehicleData();
                rateQuoteCoordService.clearLender();
                $scope.clearQuotesContractsAndProducts();
                rateQuoteRetrievalCoordService.endQuoteRetrieval();//guarantees we've ended "quote retrieval"

                //avoiding calling the "get quote integration template" API
                //
                var integrationData = new QuoteIntegrationLocal();
                var dos = myDealData.dateOfSale;
                if (dos && dos.indexOf('-') > 3) {
                    dos = dos.replace(/(\d*)-(\d*)-(\d*)/,'$2/$3/$1');
                    if (dos.indexOf('T') > 3) dos = dos.substr(0, dos.indexOf('T'))
                }
                integrationData.dateOfSale = dos ? new Date(dos).mmddyyyy(): new Date();
                switch (myDealData.saleType) {
                    case "R":
                        integrationData.saleType = "RetailFinanced";
                        break;
                    case "L":
                        integrationData.saleType = "Leased";
                        break;
                    case "B":
                        integrationData.saleType = "BalloonFinanced";
                        break;
                }
                if (myDealData.saleTerm == 1) integrationData.saleType = "Cash";
                integrationData.vehicleInfo.vin = myDealData.vehicleVIN;
                integrationData.vehicleInfo.odometer = myDealData.vehicleOdometer;
                integrationData.vehicleInfo.wMiles= myDealData.wMonths;
                integrationData.vehicleInfo.wMiles = myDealData.wMiles;
                integrationData.financialDatas[0].financingMonths = myDealData.saleTerm;
                integrationData.financialDatas[0].financingAPR = myDealData.saleAPR;
                integrationData.financialDatas[0].amountFinanced = myDealData.saleAmountFinanced;
                integrationData.financialDatas[0].sellingPrice = myDealData.vehiclePurchasePrice;
                integrationData.financialDatas[0].MSRP = myDealData.vehicleMSRP;
                integrationData.vehicleInfo.vehicleType = _AUTOVEHICLETYPE;
                rateQuoteCoordService.VehicleData.vehicleType = _AUTOVEHICLETYPE;//forcing recognition of event for AUTO
                var customerPhone = (myDealData.customerPhone && myDealData.customerPhone.indexOf('(') < 0) ? myDealData.customerPhone.replace(/-/g, '') : myDealData.customerPhone;

                if (myDealData.businessName == 'P'){
                    integrationData.businessInfo = undefined;
                    integrationData.primaryBuyerInfo.customerNumber = myDealData.customerNumber;
                    var customerFirstNameArg = myDealData.customerFirstName != undefined ? myDealData.customerFirstName.split(' ') : "";
                    integrationData.primaryBuyerInfo.firstName = customerFirstNameArg.length > 1 && myDealData.customerFirstName.indexOf(' ' + myDealData.customerMiddleName) > -1 ? customerFirstNameArg[0] : myDealData.customerFirstName;
                    integrationData.primaryBuyerInfo.middleName = myDealData.customerMiddleName;
                    integrationData.primaryBuyerInfo.lastName = myDealData.customerLastName;
                    integrationData.primaryBuyerInfo.address1 = myDealData.customerAddress1;
                    integrationData.primaryBuyerInfo.address2 = myDealData.customerAddress2;
                    integrationData.primaryBuyerInfo.city = myDealData.customerCity;
                    integrationData.primaryBuyerInfo.state = myDealData.customerState;
                    integrationData.primaryBuyerInfo.zip = myDealData.customerZip;
                    integrationData.primaryBuyerInfo.phone = customerPhone;
                }else {
                    integrationData.primaryBuyerInfo = undefined;
                    integrationData.businessInfo.businessName = myDealData.businessName;
                    integrationData.businessInfo.driverFirstName = myDealData.businessName;
                    integrationData.businessInfo.driverLastName = myDealData.customerLastName;
                    integrationData.businessInfo.address1 = myDealData.customerAddress1;
                    integrationData.businessInfo.address2 = myDealData.customerAddress2;
                    integrationData.businessInfo.city = myDealData.customerCity;
                    integrationData.businessInfo.state = myDealData.customerState;
                    integrationData.businessInfo.zip = myDealData.customerZip;
                    integrationData.businessInfo.phone = customerPhone;
                }

                integrationData.coBuyerInfo.firstName = myDealData.coCustomerFirstName;
                integrationData.coBuyerInfo.lastName = myDealData.coCustomerLastName;
                integrationData.coBuyerInfo.middleName = myDealData.coCustomerMiddleName;

                quoteIntegrationService.captureIntegrationData(integrationData);

                $rootScope.$broadcast(quoteCreationEvents.customerDataChange, {});//forcing customer card refresh
                var currentPath = $location.path();
                if (currentPath.indexOf(routes.createQuote) >= 0 ) {
                    rateQuoteCoordService.getNewGuid(false)
                        .then(function (guid) {
                            $rootScope.$broadcast(quoteCreationEvents.startNewProductQuote, {});
                            $scope.dmsInfo.dealORStockNumber = '';
                            //so that validation messages don't appear when they click new again
                            $scope.newQuoteForm.$setPristine();
                            $scope.dmsIntegrationForm.$setPristine();

                            if ($location.search()['qsession']) {
                                $location.search('');
                            }
                        });
                }
                else {
                    //in a different page, so need to redirect to create-quote
                    // date of sale has to be in mm-dd-yyyy or mm/dd/yyyy format, in order to use quote integration service
                    $location.url(routes.createQuote + '/?src=welcome');
                }
            }

        function getMInMaxDOS(vehicleDos)
        {
            $scope.minDate = new Date(
                vehicleDos.getFullYear(),
                vehicleDos.getMonth(),
                vehicleDos.getDate() -84);

            $scope.maxDate = new Date(
                vehicleDos.getFullYear(),
                vehicleDos.getMonth(),
                vehicleDos.getDate());
        }


            $scope.formatDateYYYYMMDD = function(dt){
                dt = new Date(dt);
                var day = ('0' + dt.getUTCDate()).slice(-2);
                var month = ('0' + (dt.getUTCMonth() + 1)).slice(-2);
                var year = dt.getUTCFullYear();

                return month + '-' + day + '-' + year;
            }

            $scope.clearForm = function(){
                $scope.basicInfo = {
                    vin: '',
                    odometer: null,
                    dos: dos,
                    firstName: '',
                    lastName: '',
                    providerSpecific: {} // individual properties are created by directive in this controller's view
                };
                $scope.dmsInfo.dealORStockNumber = '';
                $scope.dmsInfo.dmsDealsList = [];
                $scope.newQuoteForm.$setPristine();
                $scope.dmsIntegrationForm.$setPristine();

            }

        $scope.NewCheckDateValidity = function()
        {
            if($scope.newQuoteForm.DOS.$error.valid)
            {
                return "Invalid format date";
            }
            return "Invalid sale date";

        }
            $scope.init();
        }]);
